import { render, staticRenderFns } from "./middle3.vue?vue&type=template&id=4781ad56&scoped=true&"
import script from "./middle3.vue?vue&type=script&lang=js&"
export * from "./middle3.vue?vue&type=script&lang=js&"
import style0 from "./middle3.vue?vue&type=style&index=0&id=4781ad56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781ad56",
  null
  
)

export default component.exports